<template>
    <div style="padding: 15px;">

        <div class="materialItem" v-for="item, index in materialList" :key="index">
            <el-image :src="item.img.info.thumb" lazy :style="getImageStyle(item.img.info)" fit="scale-down">
            </el-image>
        </div>

        <el-form label-width="auto">

            <el-form-item label="选择素材组">
                <el-autocomplete v-model="queryMaterialGroup" :fetch-suggestions="querySearch" placeholder="请输入内容"
                    @select="handleSelect" clearable></el-autocomplete>
            </el-form-item>

            <el-form-item label="标题">
                <el-input v-model="myObj.word_banner_params.title"></el-input>
            </el-form-item>

            <el-form-item label="元素间距" v-if="myObj.word_banner_params.between_space == 1">
                <el-input-number v-model="myObj.word_banner_params.between_space" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="元素宽">
                <el-input-number v-model="myObj.word_banner_params.item_width" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item label="元素高">
                <el-input-number v-model="myObj.word_banner_params.item_height" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="元素圆角">
                <el-input-number v-model="myObj.word_banner_params.corner_radius" :min="0"></el-input-number>
            </el-form-item>

        </el-form>

    </div>

</template>

<script>

import { GetMaterialGroupList, GetMaterialGroupDetail } from '@/request/api'

export default {
    name: "BannerProp",
    components: {
    },
    props: ['obj'],
    data() {
        return {
            myObj: this.obj,
            queryMaterialGroup: '',
            materialList: []
        }
    },
    methods: {
        /**
         * 搜索素材组
         */
        querySearch(queryString, cb) {
            console.log('querySearch', queryString)
            const params = {}
            if (queryString) {
                params.name = queryString
            }
            GetMaterialGroupList(params)
                .then(data => {
                    var list = []
                    if (data.list) {
                        list = data.list.map(item => {
                            return {
                                value: item.name,
                                id: item.materialGroupID
                            }
                        })
                    }
                    cb(list)
                })
                .catch(error => {
                    console.error('素材组列表', error)
                })
        },
        /**
         * 选中素材组
         */
        handleSelect(item) {
            this.myObj.component_source.word_banner_params.material_group_id = item.id
            this.myObj.ignore.material_group_name = item.value
            console.log('handleSelect', item, this.myObj)
            this.getMaterialGroupDetail(item.id)
        },
        /**
         * 获取素材组详情
         */
        getMaterialGroupDetail(material_group_id) {
            GetMaterialGroupDetail(material_group_id)
                .then(data => {
                    console.log('getMaterialGroupDetail', data)
                    this.materialList = data.list
                })
        },
        /**
         * 根据宽高获取图片的样式
         */
        getImageStyle(info) {
            const width = info.width
            const height = info.height
            const standardHeight = 150
            if (height > standardHeight) {
                const sWidth = parseFloat(width) / height * standardHeight
                return 'width:' + sWidth + 'px;height:' + standardHeight + 'px'
            } else {
                return 'width:' + width + 'px;height:' + height + 'px'
            }
        }
    }
}
</script>

<style scoped lang="less">
.el-input {
    width: 120px;
}

.materialItem {
    width: 100%;
    text-align: center;
    margin-bottom: 5px;
}
</style>